function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This function maps any elastic search autocomplete options
 * to autocomplete options, useful for the SearchAutocomplete component.
 *
 * @param option -
 * The elastic search autocomplete option.
 * @param attribute -
 * The autocomplete attribute that belongs to the option.
 * @param query -
 * The current query from the searchbar.
 *
 * @returns {AutocompleteOption}
 * The mapped option, with updated _score and highlight properties.
 */
export default function mapAutocompleteOption(option, attribute) {
  let query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const {
    text,
    _score: score = 0
  } = option;
  let highlighted = text;
  let newScore = score || 0;
  query.split(' ').filter(queryPart => queryPart.length > 0).forEach(queryPart => {
    // Remove any special character from the queryPart.
    const cleanQueryPart = queryPart.replaceAll(/[^\w\d]/gi, '');

    // Replace all query parts within the text, that
    // aren't already highlighted, with highlighted strings.
    const re = new RegExp("(".concat(cleanQueryPart, ")(?![^<]*>|[^<>]*<)"), 'gi');
    highlighted = highlighted.replaceAll(re, "<em>".concat(cleanQueryPart, "</em>"));

    // Give matches a leg up in the sorting.
    if (re.test(text)) {
      newScore *= 2;
    }
  });
  return _objectSpread(_objectSpread({}, option), {}, {
    _score: newScore,
    highlight: {
      [attribute]: [highlighted]
    }
  });
}